AoPS.Utils.initKeyChain(AoPS, "Contests", "Views");

AoPS.Contests.Views = (function (Views) {
	Views.ContestPortalCoachMain = Views.CPGenericSubView.extend({
		template_id: "#contest-portal-coach-main-tpl",
		prerenderHelper: function () {
			this.vars = _.extend({}, this.parent.vars);
			this.vars.academy_url = this.model.get("master").get("academy_url");
			this.filterFAQs("coach");
			// can generalize this if condition to work for all special-managed portals in the future
			if (this.model.get("contest_hash") === "putnam") {
				this.initSpecialManageStudentNames("L, F M");
				this.sortSpecialManageStudents();
			}
			this.getTemplateVariables();
		},
		renderHelper: function () {
			_.each(this.vars.invitations, _.bind(this.processInvitation, this));
			_.each(
				this.vars.portal_user.students,
				_.bind(this.processSpecialManageStudent, this)
			);

			_.each(
				this.$(".hover-tooltip"),
				_.bind(function (el) {
					AoPS.Contests.Utils.CreateTooltip($(el), $(el).attr("title"));
				}, this)
			);

			if (this.vars.coach_show_upload && this.vars.portal_user.portal_user_id) {
				this.showUploadForCoach();
			}

			AoPS.Contests.Utils.setFAQsEventListeners();
			AoPS.Contests.Utils.scrollTo();
		},
		/**
		 * Formats names for special-managed portals like the Putnam.
		 *
		 * @param {string} format Format for the names - F = first, M = middle, L = last
		 */
		initSpecialManageStudentNames(format = "F M L") {
			if (!this.model.get("master").get("contest_portal_users").models) {
				return;
			}

			_.each(
				this.model.get("master").get("contest_portal_users").models,
				function (cpu) {
					if (!cpu || !cpu.get("students") || !cpu.get("students").length) {
						return;
					}
					_.each(cpu.get("students"), function (student) {
						var name_arr = [];
						for (var char of format.split("")) {
							switch (char) {
								case "F":
									name_arr.push(student.data.first_name);
									break;
								case "M":
									name_arr.push(student.data.middle_initial);
									break;
								case "L":
									name_arr.push(student.data.last_name);
									break;
								default:
									name_arr.push(char);
							}
						}
						student.name_fmt = name_arr.join("");
					});
				}
			);
		},
		/**
		 * Sort by status (pending->approved->rejected), then by name.
		 * This is done for special managed coach portals like the Putnam.
		 */
		sortSpecialManageStudents() {
			if (!this.model.get("master").get("contest_portal_users").models) {
				return;
			}

			function getStudentPriority(student) {
				if (student.registered_at) {
					return 0; // approved
				}
				if (student.rejected_at) {
					return -1; // rejected
				}
				return 1; // pending
			}

			// sort by status (pending->approved->rejected), then by name
			_.each(
				this.model.get("master").get("contest_portal_users").models,
				function (cpu) {
					if (!cpu || !cpu.get("students") || !cpu.get("students").length) {
						return;
					}
					cpu.get("students").sort((s1, s2) => {
						var p1 = getStudentPriority(s1);
						var p2 = getStudentPriority(s2);

						// sort by priority if not the same
						if (p1 !== p2) {
							return p2 - p1;
						}

						// otherwise, sort by name
						return s1.name_fmt.localeCompare(s2.name_fmt);
					});
				}
			);
		},
		processSpecialManageStudent: function (student) {
			var $tr = this.$(
				".student.contest-" +
					student.contest_id +
					"-host-" +
					student.host_id +
					"-user-" +
					student.user_id
			);

			var lock_approve = false;
			var lock_reject = false;
			var end_at = this.vars.window.official_individual_contest_end_at;
			if (end_at) {
				var lock_approve_time = moment(end_at, "YYYY-MM-DD HH:mm:ss");
				var lock_reject_time = moment(end_at, "YYYY-MM-DD HH:mm:ss");
				// keep reject button open strictly up to 1 week after Putnam ends
				if (this.vars.contest_hash === "putnam") {
					lock_reject_time.add(1, "weeks");
				}
				lock_approve = lock_approve_time.isBefore(moment());
				lock_reject = lock_reject_time.isBefore(moment());
			}

			if (lock_approve || student.registered_at) {
				$tr
					.find(".approve")
					.addClass("disabled")
					.css({"pointer-events": "none"});
			} else {
				$tr.find(".approve").click(
					_.bind(function () {
						this.processActionSpecialManageStudent(student, "approve");
					}, this)
				);
			}

			if (lock_reject || student.rejected_at) {
				$tr
					.find(".reject")
					.addClass("disabled")
					.css({"pointer-events": "none"});
			} else {
				$tr.find(".reject").click(
					_.bind(function () {
						this.processActionSpecialManageStudent(student, "reject");
					}, this)
				);
			}
		},
		processInvitation: function (invitation) {
			this.$(
				".copy-invitation-link.contest-" +
					invitation.contest_id +
					"-host-" +
					invitation.host_id
			).click(
				_.bind(function () {
					AoPS.Contests.Utils.copyTextToClipboard(
						invitation.url,
						function () {
							AoPS.Contests.Utils.CreateModalAlert("URL copied to clipboard!");
						},
						function () {
							AoPS.Contests.Utils.CreateModalAlert("Copy Failed!");
						}
					);
				}, this)
			);

			_.each(
				invitation.students,
				_.bind(function (student) {
					this.processStudent(invitation, student);
				}, this)
			);

			if ((this.vars.flavor || {}).has_team) {
				this.processTeam(invitation);
			}
		},
		processStudent: function (invitation, student) {
			var $tr = this.$(
				".student.contest-" +
					invitation.contest_id +
					"-host-" +
					invitation.host_id +
					"-user-" +
					student.user_id
			);

			if (!AoPS.bootstrap_data.disable_is_official_checkbox) {
				$tr.find(".is-official input").click(
					_.bind(function (e) {
						e.preventDefault();
						this.processIsOfficialCheckbox(invitation, student);
					}, this)
				);
			} else {
				$tr.find(".is-official input").prop("disabled", true);
			}

			if (student.official_status) {
				// Do not show the remove button of the student has an entry that's been started.
				$tr
					.find(".remove")
					.addClass("disabled")
					.css({"pointer-events": "none"});
			} else {
				$tr.find(".remove").click(
					_.bind(function () {
						this.processRemoveInvitedStudent(invitation, student);
					}, this)
				);
			}

			$tr.find(".password").click(
				_.bind(function () {
					this.processUpdateInvitedStudentPassword(invitation, student);
				}, this)
			);

			$tr.find(".proctoring.unlocked").click(
				_.bind(function (input) {
					this.model.updateInvitedStudent({
						user_id: student.user_id,
						contest_id: invitation.contest_id,
						host_id: invitation.host_id,
						name: "proctored_by_coach",
						value: input.target.checked ? 1 : 0,
					});
				}, this)
			);
		},
		processActionSpecialManageStudent: function (student, action) {
			if (action !== "approve" && action !== "reject") {
				AoPS.Contests.Utils.CreateModalAlert(
					"Error: Invalid action (" +
						action +
						"). Please click OK to refresh the page.",
					function () {
						location.reload();
					}
				);
				return;
			}

			var self = this;
			var updateStudent = function () {
				self.model.updateSpecialManageStudent({
					action: action,
					contest_id: student.contest_id,
					host_id: student.host_id,
					user_id: student.user_id,
				});
			};

			// only trigger confirmation modal for rejections (T50153)
			if (action === "reject") {
				AoPS.Contests.Utils.CreateModalConfirm(
					$("<div />")
						.css("max-width", "480px")
						.html(
							this.model.getCmsTemplate(
								"#contest-portal-coach-modal-action-requested-student-tpl",
								_.extend(
									{
										action: action,
										student_name: student.name,
									},
									this.vars
								)
							)
						),
					updateStudent,
					null,
					{
						confirm_button_ok: "YES",
						confirm_button_cancel: "NO",
					}
				);
			} else {
				updateStudent();
			}
		},
		processIsOfficialCheckbox: function (invitation, student) {
			if (!student.is_official && invitation.num_official_remain <= 0) {
				AoPS.Contests.Utils.CreateModalAlert(
					"You are currently at the limit of " +
						invitation.num_official_total +
						" official " +
						(this.vars.terms.student || {})[
							invitation.num_official_total_is_plural
								? "plural_lc"
								: "singular_lc"
						] +
						"."
				);
			} else {
				this.model.updateInvitedStudent({
					contest_id: invitation.contest_id,
					host_id: invitation.host_id,
					user_id: student.user_id,
					name: "is_official",
					value: student.is_official ? 0 : 1,
				});
			}
		},
		processRemoveInvitedStudent: function (invitation, student) {
			var student_name = student.name
				? student.name + " (" + student.username + ")"
				: student.username;

			AoPS.Contests.Utils.CreateModalConfirm(
				$("<div />")
					.css("max-width", "480px")
					.html(
						this.model.getCmsTemplate(
							"#contest-portal-coach-modal-remove-student-tpl",
							_.extend(
								{student_name: student_name, invitation: invitation},
								this.vars
							)
						)
					),
				_.bind(function () {
					this.model.removeInvitedStudent({
						contest_id: invitation.contest_id,
						host_id: invitation.host_id,
						user_id: student.user_id,
					});
				}, this),
				null,
				{
					confirm_button_ok: "YES",
					confirm_button_cancel: "NO",
				}
			);
		},
		processUpdateInvitedStudentPassword: function (invitation, student) {
			var student_name = student.name
				? student.name + " (" + student.username + ")"
				: student.username;

			if (student.is_full_user) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.css("word-break", "break-all")
						.text(
							"Passwords can only be updated for " +
								((this.vars.terms.student || {}).plural_lc || "students") +
								" that have limited accounts. "
						)
						.append($("<b />").text(student_name))
						.append(" can reset their password by going here: ")
						.append($("<br>"))
						.append($("<b />").text(AoPS.bootstrap_data.forgot_password_url))
				);
			} else {
				AoPS.Contests.Utils.CreateModalPrompt(
					$("<div />")
						.text("Please enter a new password for ")
						.append($("<b />").text(student_name).append(":")),
					"",
					_.bind(function (password) {
						this.model.updateInvitedStudentPassword({
							contest_id: invitation.contest_id,
							host_id: invitation.host_id,
							user_id: student.user_id,
							password: password,
						});
					}, this)
				);
			}
		},
		processTeam: function (invitation) {
			if (
				!_.filter(
					invitation.students,
					_.bind(function (student) {
						return (
							student.registered_at &&
							_.reduce(
								invitation.teams,
								function (carry, team) {
									return (
										carry &&
										!_.findWhere(team.members, {user_id: student.user_id})
									);
								},
								true
							)
						);
					}, this)
				).length
			) {
				this.$(
					".add-new-team.contest-" +
						invitation.contest_id +
						"-host-" +
						invitation.host_id
				).hide();
			}

			this.$(
				".add-new-team.contest-" +
					invitation.contest_id +
					"-host-" +
					invitation.host_id
			).click(
				_.bind(function () {
					var popup = new Views.ContestPortalCoachTeamModal({
						model: this.model,
						invitation: invitation,
						parent: this,
						root: this.root,
					});
					popup.modal = popup.$el.showPlainModal({
						scrollable: true,
						onClose: function () {
							popup.close();
						},
					});
				}, this)
			);

			_.each(
				invitation.teams,
				_.bind(function (team) {
					this.$(".edit-team-" + team.team_id).click(
						_.bind(function () {
							var popup = new Views.ContestPortalCoachTeamModal({
								model: this.model,
								invitation: invitation,
								team: team,
								parent: this,
								root: this.root,
							});
							popup.modal = popup.$el.showPlainModal({
								scrollable: true,
								onClose: function () {
									popup.close();
								},
							});
						}, this)
					);

					this.$(".remove-team-" + team.team_id).click(
						_.bind(function () {
							AoPS.Contests.Utils.CreateModalConfirm(
								$("<div />")
									.css("max-width", "480px")
									.text("Are you sure that you want to remove this team?"),
								_.bind(function () {
									this.model.updateTeam({
										team_id: team.team_id,
										host_id: invitation.host_id,
										json_array_member_ids: JSON.stringify([]),
									});
								}, this),
								null,
								{
									confirm_button_ok: "YES",
									confirm_button_cancel: "NO",
								}
							);
						}, this)
					);
				}, this)
			);
		},
		/**
		 * show the upload form for Putnam coach
		 */
		showUploadForCoach: function () {
			if (_.isUndefined(this.uploadForm)) {
				this.uploadForm = new Views.ContestPortalCoachUpload({
					model: this.model,
					parent: this,
					root: this.root,
				});
			}
			this.uploadForm.$el.appendTo(this.$el);
		},
	});

	Views.ContestPortalCoachTeamModal = Views.CPGenericSubView.extend({
		className: "contest-team-modal",
		template_id: "#contest-portal-coach-team-modal-tpl",
		prerenderHelper: function () {
			var otherTeams = _.without(
				this.options.invitation.teams,
				this.options.team
			);

			this.vars = _.extend(
				{
					team: this.options.team,
					invitation: this.options.invitation,
					slots: _.map(
						_.range((this.parent.vars.flavor || {}).max_team_size || 1),
						_.bind(function (index) {
							return {
								index: index,
								caption: index + 1,
								selected: this.options.team
									? (this.options.team.slots[index] || {}).user_id || 0
									: 0,
							};
						}, this)
					),
					available: _.sortBy(
						_.filter(
							this.options.invitation.students,
							_.bind(function (student) {
								return (
									student.registered_at &&
									_.reduce(
										otherTeams,
										function (carry, team) {
											return (
												carry &&
												!_.findWhere(team.members, {user_id: student.user_id})
											);
										},
										true
									)
								);
							}, this)
						),
						"name"
					),
				},
				this.parent.vars
			);
		},
		updateOptionsForSlot: function (slot) {
			slot.$select =
				slot.$select || this.$('select[name="member-' + slot.index + '"]');
			slot.$select
				.empty()
				.append($("<option />").val("0").text("None Selected"));

			_.each(
				_.filter(
					this.vars.available,
					_.bind(function (student) {
						return (
							_.pluck(_.without(this.vars.slots, slot), "selected").indexOf(
								student.user_id
							) < 0
						);
					}, this)
				),
				_.bind(function (student) {
					slot.$select.append(
						$("<option />")
							.val(student.user_id)
							.text(student.name + " (" + student.username + ")")
							.prop("selected", student.user_id === slot.selected)
					);
				}, this)
			);
		},
		closeModal: function () {
			AoPS.Ui.Modal.removeModal(this.modal);
		},
		saveTeam: function () {
			var user_ids = _.reduce(
				this.vars.slots,
				function (carry, slot) {
					if (slot.selected) {
						carry.push(slot.selected);
					}
					return carry;
				},
				[]
			);
			if (user_ids.length) {
				this.model.updateTeam({
					team_id: (this.vars.team || {}).team_id || 0,
					host_id: this.vars.invitation.host_id,
					json_array_member_ids: JSON.stringify(user_ids),
				});
				this.closeModal();
			} else {
				AoPS.Contests.Utils.CreateModalAlert(
					"Please select one or more " +
						this.vars.terms.student.plural_lc +
						" for this team."
				);
			}
		},
		renderHelper: function () {
			_.each(
				this.vars.slots,
				_.bind(function (slot) {
					this.updateOptionsForSlot(slot);
					slot.$select.change(
						_.bind(function () {
							slot.selected = parseInt(slot.$select.val()) || 0;
							_.each(
								_.without(this.vars.slots, slot),
								_.bind(this.updateOptionsForSlot, this)
							);
						}, this)
					);
				}, this)
			);

			this.$(".save").click(_.bind(this.saveTeam, this));

			this.$(".cancel").click(_.bind(this.closeModal, this));
		},
	});

	Views.ContestPortalCoachUpload = Views.CPGenericSubView.extend({
		className: "portal-section contest-portal-coach-upload",
		template_id: "#contest-portal-coach-upload-tpl",
		initialize: function (options) {
			this.parent = options.parent;
			this.root = options.root;
			this.options = options;
			this.$el.text("Loading Student Submissions...");
			this.model.get("master").getStudentUploadData(
				{portal_user_id: this.parent.vars.portal_user.portal_user_id},
				_.bind(this.loadDataAndRender, this),
				_.bind(function () {
					this.$el.text("Loading Student Submissions Failed!");
				}, this)
			);
			this.removeHighlight = _.debounce(
				_.bind(function () {
					this.$(".highlight").removeClass("highlight");
				}, this),
				5000
			);
		},
		loadDataAndRender: function (data, highlight) {
			this.uploadData = _.extend(
				this.uploadData || {students: []},
				_.omit(data, "students")
			);
			_.each(this.uploadData.students, function (student) {
				student.highlight = false;
			});
			_.each(
				data.students || [],
				_.bind(function (student) {
					var found = _.findWhere(this.uploadData.students, {
						user_id: student.user_id,
					});
					if (found) {
						_.extend(found, student, {highlight: highlight ? true : false});
					} else {
						this.uploadData.students.push(
							_.extend({highlight: highlight ? true : false}, student)
						);
					}
				}, this)
			);
			this.render();
		},
		prerenderHelper: function () {
			this.vars = _.extend({}, this.uploadData, this.parent.vars);
		},
		renderHelper: function () {
			if (this.vars.can_edit) {
				_.each(
					this.uploadData.students || [],
					_.bind(function (student) {
						this.$(".edit-upload-user-id-" + student.user_id).click(
							_.bind(function (event) {
								this.onClickStudentRow(event, student);
							}, this)
						);
					}, this)
				);
			}

			_.each(
				this.uploadData.students || [],
				_.bind(function (student) {
					_.each(
						student.problems,
						_.bind(function (problem) {
							if (problem.submission) {
								var $fileLink = this.$(
									".file-" + student.user_id + "-" + problem.problem_id
								);
								$fileLink.click(function (event) {
									event.stopPropagation();
								});
								AoPS.Contests.Utils.CreateTooltip(
									$fileLink,
									$("<div />")
										.text("Click to view ")
										.append(
											$("<b />").text(problem.submission.pretty_file_name)
										)
								);
							}
						}, this)
					);
				}, this)
			);

			if (this.$(".highlight").length) {
				this.removeHighlight();
			}
		},
		onClickStudentRow: function (event, student) {
			if (student) {
				var popup = new Views.ContestPortalCoachUploadStudentModal({
					model: this.model,
					student: student,
					parent: this,
					root: this.root,
				});
				popup.modal = popup.$el.showPlainModal({
					scrollable: true,
					force_response: true,
					onClose: function () {
						popup.close();
					},
				});
			}
		},
	});

	Views.ContestPortalCoachUploadStudentModal = Views.CPGenericSubView.extend({
		className: "contest-portal-coach-upload-student-modal",
		template_id: "#contest-portal-coach-upload-student-modal-tpl",
		prerenderHelper: function () {
			this.vars = _.extend(
				{
					selectedStudent: _.extend(
						{
							linkedProblems: _.map(
								this.options.student.problems,
								_.bind(function (problem) {
									return _.extend(
										{
											problem: _.findWhere(this.parent.uploadData.problems, {
												contest_problem_id: problem.problem_id,
											}),
										},
										problem
									);
								}, this)
							),
						},
						this.options.student
					),
				},
				this.parent.vars
			);
		},
		closeModal: function () {
			AoPS.Ui.Modal.removeModal(this.modal);
		},
		renderHelper: function () {
			_.each(
				this.vars.selectedStudent.linkedProblems,
				_.bind(this.renderHelperForProblem, this)
			);

			this.$("form").submit(function (event) {
				event.preventDefault();
			});

			this.$(".save").click(
				_.bind(function (event) {
					event.preventDefault();
					this.saveStudentUploads();
				}, this)
			);

			this.$(".cancel").click(
				_.bind(function (event) {
					event.preventDefault();
					this.closeModal();
				}, this)
			);
		},
		renderHelperForProblem: function (item) {
			var $row = this.$(".row-problem-id-" + item.problem_id);
			var $reset = $row.find(".reset").hide();
			var $file = $row.find(".file-column");
			var $upload = $row.find(".upload");
			var $delete = $row.find(".delete");
			var $view = $row.find(".view-column");

			var updateEverything = _.bind(function () {
				if ($delete.prop("checked")) {
					$row.addClass("delete");
					$upload.hide();
					$reset.hide();
				} else {
					$row.removeClass("delete");
					$upload.show();
					$reset.toggle($upload.val() ? true : false);
				}

				if (!$delete.prop("checked") && ($upload.val() || item.submission)) {
					$file.find("span").text("q");
					$file.addClass("has-file");
					if (!item.submission) {
						$view.html("<i>Pending</i>");
					}
				} else {
					$file.find("span").text("J");
					$file.removeClass("has-file");
					if (!item.submission) {
						$view.html("<i>None</i>");
					}
				}
			});

			$delete.change(updateEverything);
			$upload.change(
				_.bind(function () {
					if ($upload.val()) {
						if ($upload[0] && $upload[0].files && $upload[0].files[0]) {
							var file = $upload[0].files[0];
							if (!file.size) {
								AoPS.Contests.Utils.CreateModalAlert(
									"Please select a valid file and verify that you are using a recent browser."
								);
								$upload.val("");
							} else if (
								file.type !== "application/pdf" ||
								!file.name.match(/\.pdf$/i)
							) {
								AoPS.Contests.Utils.CreateModalAlert(
									"Please select a PDF file."
								);
								$upload.val("");
							} else if (file.size >= 1024 * 1024 * 8) {
								AoPS.Contests.Utils.CreateModalAlert(
									"This file is too large. Please resize it to be smaller than 8 MB."
								);
								$upload.val("");
							}
						} else {
							AoPS.Contests.Utils.CreateModalAlert(
								"Error processing file. Please verify that you're using a recent browser."
							);
							$upload.val("");
						}
					}

					updateEverything();
				}, this)
			);
			$reset.click(
				_.bind(function () {
					$upload.val("");
					updateEverything();
				}, this)
			);
		},
		saveStudentUploads: function () {
			this.executeStudentUploadState(
				_.reduce(
					this.vars.selectedStudent.linkedProblems,
					_.bind(function (state, problem) {
						var $delete = this.$(
							"input[name='delete[" + problem.problem_id + "]']"
						);
						var $upload = this.$(
							"input[name='upload[" + problem.problem_id + "]']"
						);

						if ($delete && $delete.prop("checked")) {
							state.delete.push(problem);
						} else if (
							$upload.val() &&
							$upload[0] &&
							$upload[0].files &&
							$upload[0].files[0]
						) {
							state.upload.push(_.extend({file: $upload[0].files[0]}, problem));
						}

						return state;
					}, this),
					{
						upload: [],
						delete: [],
					}
				)
			);
		},
		executeStudentUploadState: function (state) {
			if (state.upload.length) {
				this.popUploadAndExecute(state);
			} else {
				this.saveEntry(state);
			}
		},
		popUploadAndExecute: function (state) {
			var self = this;
			var toUpload = _.first(state.upload);
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable(
				$("<div />")
					.css("padding", "10px 15px")
					.text("Uploading ")
					.append($("<b />").text(toUpload.file.name))
					.append(" for ")
					.append($("<b />").text("Problem " + toUpload.problem.display_number))
					.append(" (" + (state.upload.length - 1) + " remaining)...")
			);

			var formData = new FormData();
			var request = new XMLHttpRequest();

			formData.append(
				"client_updated_at",
				moment().format("YYYY-MM-DD HH:mm:ss")
			);
			formData.append("contest_id", this.model.get("contest_id"));
			formData.append("segment_id", toUpload.problem.segment_index);
			formData.append("problem_id", toUpload.problem_id);
			formData.append("round_id", toUpload.problem.contest_round_id);
			formData.append("display_problem_id", toUpload.problem.display_number);
			formData.append(
				"registration_id",
				this.vars.selectedStudent.contest_registration_id
			);
			formData.append("user_id", this.vars.selectedStudent.user_id);
			formData.append("force_create_grading_rows", true);
			formData.append("file", toUpload.file);

			request.open("POST", "/m/contests/dropzone_problem_upload.php");
			request.send(formData);
			request.onreadystatechange = function () {
				if (this.readyState === 4) {
					AoPS.Ui.Modal.removeModal(loadingModal);
					try {
						var response = JSON.parse(this.response);
						if (response.error_msg) {
							AoPS.Contests.Utils.CreateModalAlert(response.error_msg);
						} else {
							self.executeStudentUploadState({
								upload: _.without(state.upload, toUpload),
								delete: state.delete,
							});
						}
					} catch (error) {
						AoPS.Contests.Utils.CreateModalAlert("Unknown Error Occurred!");
					}
				}
			};
		},
		saveEntry: function (state) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable(
				"Saving Submission..."
			);
			this.model.get("master").getStudentUploadData(
				{
					portal_user_id: this.parent.vars.portal_user.portal_user_id,
					student_user_id: this.vars.selectedStudent.user_id,
					delete_problem_ids: _.pluck(state.delete, "problem_id").join(","),
					save_entry: 1,
				},
				_.bind(function (data) {
					AoPS.Ui.Modal.removeModal(loadingModal);
					this.closeModal();
					this.parent.loadDataAndRender(data, true);
				}, this),
				_.bind(function (data) {
					AoPS.Ui.Modal.removeModal(loadingModal);
				}, this)
			);
		},
	});

	return Views;
})(AoPS.Contests.Views || {});
